'use client';

import { useSyncExternalStore } from 'react';

const MOBILE_QUERY = '(max-width: 767px)';

const subscribe = (callback: () => void): (() => void) => {
  const mq = window.matchMedia(MOBILE_QUERY);
  mq.addEventListener('change', callback);
  return () => mq.removeEventListener('change', callback);
};

const getSnapshot = (): boolean => window.matchMedia(MOBILE_QUERY).matches;

const getServerSnapshot = (): boolean => false;

/**
 * Shared mobile breakpoint used by package layouts. Keeps the existing 767px
 * breakpoint and the server snapshot (`false`) so SSR output stays unchanged.
 */
export function useIsMobile(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

export default useIsMobile;
